import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Tooltip from "@mui/material/Tooltip";
import When from "ui/support/When";

type Props = {
    readonly hasRequestedChange?: boolean;
};

const StepRequestedChangeFiledsIndicator = ({ hasRequestedChange = false }: Props) => (
    <Box
        sx={{
            justifySelf: 'center',
            alignSelf: 'center'
        }}
    >
        <When
            if={hasRequestedChange}
            then={(
                <Tooltip
                    arrow
                    title='This step has requested changes'
                    placement='top'
                >
                    <IconButton
                        color='warning'
                    >
                        <WarningAmberIcon />
                    </IconButton>
                </Tooltip>
            )}
        />
    </Box>
);

export default StepRequestedChangeFiledsIndicator;
